import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { Avatar, Chip, useTheme } from "@mui/material";

export const UserChip = ({
  name,
  avatar,
}: {
  name?: string | null;
  avatar?: string | null;
}) => {
  const { t } = useResource();
  const { colors } = useTheme();
  const displayName = name || t(Resources.RequestCards.Common.UnknownUser);

  return (
    <Chip
      avatar={
        <Avatar sx={{ width: 24, height: 24 }} src={avatar || undefined}>
          {displayName.charAt(0)}
        </Avatar>
      }
      label={displayName}
      variant="outlined"
      size="small"
      sx={{
        backgroundColor: colors.background.tertiary,
        border: "1px solid",
        borderColor: colors.border.primary,
        "& .MuiChip-label": { fontSize: "0.75rem" },
      }}
    />
  );
};
